/* The Quote page's own panels (piece 22): the Item Table over the lines, the
   version history with its side-by-side comparison, and the footer whose one
   primary action the status decides. */

.lines,
.versions {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.linesFooter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-2);
}

.versionList {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.version {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2);
  padding: var(--space-1) 0;
  border-bottom: 1px solid var(--surface-2);
}

.versionHeading {
  font-weight: var(--font-weight-semibold);
}

.versionDetail {
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

.compareBar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-2);
}

.comparison {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-2);
  border: 1px solid var(--surface-2);
  border-radius: var(--radius-small);
  background: var(--surface-disabled);
}

.difference {
  margin: 0;
  font-size: var(--font-size-caption);
}

/* The footer sits under the canvas and wraps to a column on a phone, so the
   primary action is never pushed off the side of the screen. */
/* 🔨 No rule and no spacing of its own: it sits in the shell's footer, which draws both (decision 0459). */
.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
}

.refusal {
  color: var(--status-warning-text);
  font-size: var(--font-size-caption);
}

/* Why a frozen revision offers no control: a sentence in the footer's own row, not an alarm. */
.footerNote {
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

/* The accept window's optional lines, one tick each (decision 2650). */
.optionalTaken {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  border: none;
  min-width: 0;
}

/* Who accepted the Quote, on its page (decision 2650). */
.acceptance {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin: 0;
  font-size: var(--font-size-small);
  color: var(--text);
}

.acceptanceTaken {
  color: var(--text-muted);
}
